import { useAppSelector } from '../../store/hooks';
import { selectViewerMode } from '../../store/slices/shareSlice';

export const useViewerMode = () => useAppSelector(selectViewerMode);
